<template>
	<SimpleModal @close="$emit('close')">
		<div class="container">
			<h3 v-t="'meetings_actionsheet_observing_title'" />
			<div class="action-row">
				<div
					class="action-label"
					:class="{ 'disabled-action-label': !audio }"
					aria-hidden="true"
				>
					<div class="action-icon" :class="{ active: audio }">
						<MicOnIcon v-if="audio" :color="activeColor" class="mic" />
						<MicOffIcon v-if="!audio" :color="inactiveColor" class="mic" />
					</div>
					{{ $t(`meetings_actionsheet_audio_${audio ? 'on' : 'off'}`) }}
				</div>
				<ToggleSwitch
					v-model="audio"
					light
					:aria-label="
						audio
							? $t('meetings_audio_disable_alt')
							: $t('meetings_audio_enable_alt')
					"
				/>
			</div>
			<div class="divider" />
			<div class="action-row">
				<div
					class="action-label"
					:class="{ 'disabled-action-label': !video }"
					aria-hidden="true"
				>
					<div class="action-icon" :class="{ active: video }">
						<CameraOnIcon v-if="video" :color="activeColor" class="camera" />
						<CameraOffIcon
							v-if="!video"
							:color="inactiveColor"
							class="camera"
						/>
					</div>
					{{ $t(`meetings_actionsheet_video_${video ? 'on' : 'off'}`) }}
				</div>
				<ToggleSwitch
					v-model="video"
					light
					:aria-label="
						video
							? $t('meetings_video_disable_alt')
							: $t('meetings_video_enable_alt')
					"
				/>
			</div>
			<button
				class="action-button primary block"
				@click="savePrefs"
				@keyup.enter="savePrefs"
				:disabled="!audio && !video"
				:aria-label="$t('meetings_actionsheet_button_join')"
				v-t="$t('meetings_actionsheet_button_join')"
			/>
			<div class="divider" />
			<button
				class="action-button block"
				@click="$emit('close')"
				@keyup.enter="$emit('close')"
				:aria-label="$t('meetings_actionsheet_button_continue_observing')"
				v-t="$t('meetings_actionsheet_button_continue_observing')"
			/>
		</div>
	</SimpleModal>
</template>

<script>
import { SimpleModal } from '../common'
import { CameraOnIcon, CameraOffIcon, MicOnIcon, MicOffIcon } from '@/icons'
import { logMeetingEvent, setUserPrefs } from './data'
import { ToggleSwitch } from '@/components/common'

const activeColor = '#5a91f9'
const inactiveColor = '#c6cace'

export default {
	name: 'JoinMeetingPopup',
	components: {
		SimpleModal,
		CameraOnIcon,
		CameraOffIcon,
		MicOnIcon,
		MicOffIcon,
		ToggleSwitch,
	},
	data() {
		return {
			video: false,
			audio: false,
			activeColor,
			inactiveColor,
		}
	},
	emits: ['close', 'broadcast'],
	mounted() {
		logMeetingEvent('JoinMeetingPopup', 'mounted')
	},
	methods: {
		savePrefs() {
			const { video, audio, language } = this
			logMeetingEvent('JoinMeetingPopup', 'setting user prefs', {
				video,
				audio,
				language,
			})
			setUserPrefs({ video, audio, language })
			this.$emit('broadcast')
		},
	},
}
</script>

<style lang="scss" scoped>
$blue: rgb(90, 145, 249);
$gray: #c6cace;

.container {
	max-width: 375px;
	padding: 32px 50px;
}

h3 {
	font-family: 'Avenir-Heavy';
	font-weight: normal;
	font-size: 24px;
	margin-block-start: 10px;
	margin-block-end: 40px;
	color: #3a3a3a;
}

.action-row {
	cursor: pointer;
	display: flex;
	align-items: center;
	justify-content: space-between;
	width: 100%;
	.action-label {
		font-size: 16px;
		display: flex;
		align-items: center;
		font-family: Avenir Heavy;
		font-weight: normal;
		color: #5a91f9;
		.action-icon {
			display: flex;
			align-items: center;
			width: 45px;
			height: 36px;
			margin-right: 7px;
			&.active {
				.camera {
					width: 37px;
					height: 24px;
					margin-left: 2px;
				}
				.mic {
					width: 22px;
					height: 34px;
					margin-left: 4px;
				}
			}
		}
	}
	.pronto-toggle {
		font-size: 27px;
		&.active {
			background: $blue;
		}
	}
}

.disabled-action-label {
	color: #9ea2a6 !important;
	font-family: 'Avenir-Medium' !important;
}

.camera {
	width: 37px;
	height: 36px;
	margin-left: 1px;
}

.mic {
	width: 28px;
	height: 34px;
	margin-left: 2px;
}

a {
	text-decoration: none;
	outline: none;
	display: block;
	width: 100%;
	text-align: center;
}

.divider {
	border-top: 1px solid #e2e4e6;
	margin: 16px 0;
	width: 100%;
}

.action-button {
	font-size: 14px;
	font-family: Avenir-Medium;
	padding: 8px 16px;
	border-radius: 20px;
	color: #4f5053;
	background: #eee;
	&.primary {
		color: white;
		background: $blue;
		margin-top: 24px;
	}
	&.block {
		display: block;
		width: 100%;
		text-align: center;
	}
	&:disabled {
		opacity: 0.6;
		cursor: default;
	}
}
</style>
